const appContext = require('od-modules/xsell/config/app_context');

function isHsaAvailableDesktop(isPrime) {
    return Odigeo.AB.isHSAFunnelEnabled && (isPrime || !Odigeo.AB.isHsaPrimeLoggedDesktop);
}
function isHsaAvailableMobile(isPrime) {
    return Odigeo.AB.isHSAFunnelEnabledMobile && (isPrime || !Odigeo.AB.isHsaPrimeLoggedMobile);
}
function isHsaAvailable(isPrime) {
    return appContext.getFlow() === 'desktop' ? isHsaAvailableDesktop(isPrime) : isHsaAvailableMobile(isPrime);
}

module.exports = isHsaAvailable;
